module.exports = __webpack_public_path__ + "img/bubble3.38233d42.svg";